import { Box, Button, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { useNavigate } from "react-router-dom";

export const NotFoundPage = () => {
	const navigate = useNavigate();

	return (
		<Box
			sx={{
				minHeight: "60vh",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				textAlign: "center",
				px: 3,
				gap: 1.5
			}}
		>
			<Typography variant="h5" fontWeight={600}>
				Resource not found
			</Typography>
			<Typography color="text.secondary">
				The page you are looking for does not exist or may have been
				moved.
			</Typography>
			<Button
				variant="contained"
				startIcon={<HomeIcon />}
				onClick={() => navigate("/")}
			>
				Go to Home
			</Button>
		</Box>
	);
};
